module.exports = __webpack_public_path__ + "img/ADA-icon.b0dd43ca.svg";